import {useEffect} from 'react';
import PropTypes from 'prop-types';

const ExternalRedirect = ({absoluteUrl}) => {
  useEffect(() => {
    window.location.replace(absoluteUrl);
  }, [absoluteUrl]);

  return null;
};

ExternalRedirect.propTypes = {
  absoluteUrl: PropTypes.string.isRequired,
};

export default ExternalRedirect;
